import React from 'react'
import PropTypes from 'prop-types'

import IconAlert from '@/checkout-instore-legacy/components/Commons/Icons/Alert'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'
import Info from './Info'
import { FormattedMessage } from 'react-intl'
import Button from '@/checkout-instore-legacy/components/Commons/Elements/Button'

const ErrorInfo = (props) => {
  const iconSize = props.mediaQuery({
    desktop: 140,
    tablet: 230,
    phone: 120,
  })

  const handleReportError = props.reportError
  return (
    <Info
      Icon={<IconAlert width={iconSize} height={iconSize} color="#FF725C" />}
      titleExtraStyle="red"
      extraButton={
        handleReportError ? (
          <Button
            id="notifier-error-report"
            kind="danger"
            size="lg"
            onClick={handleReportError}
          >
            {props.errorReported ? (
              <i className="fa fa-ok" aria-hidden="true" />
            ) : (
              <span>
                <FormattedMessage id="reportError" />
              </span>
            )}
          </Button>
        ) : null
      }
      {...props}
    />
  )
}

ErrorInfo.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  retry: PropTypes.func,
  giveUp: PropTypes.func,
  retryText: PropTypes.string,
  giveUpText: PropTypes.string,
  mediaQuery: PropTypes.func.isRequired,
  errorReported: PropTypes.bool,
  reportError: PropTypes.func,
}

export default withMediaQuery(ErrorInfo)
